import React, { useEffect, useState } from "react";
import moment from "moment";
import * as MatStyled from "@mui/material/styles";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
// import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import { getLocale } from "react-i18nify";
import Stack from "@mui/material/Stack";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DescriptionIcon from "@mui/icons-material/Description";
import EditNoteIcon from "@mui/icons-material/EditNote";

// import { makeStyles } from '@material-ui/core'

import { DataGrid } from "@mui/x-data-grid";
import { GridActionsCellItem } from "@mui/x-data-grid";
// import Pagination from "@mui/material/Pagination";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import { useDialog } from "src/context/DialogContext";
import { getSellerListAdmin } from "src/api/seller";
import ModalSetSellNow from "./ModalSetSellNow";
import SetDeliveryTypeDialog from "./SetDeliveryTypeDialog";
import TermDialog from "./TermDialog";
import { useAuth } from "src/hooks/useAuth";
import SetTermContractFeeDialog from "./SetTermContractFeeDialog";

const DivCount = styled.div`
  width: 98%;
  margin: 8px;
`;

const SpanTextCount = styled.span`
  font-weight: 400;
  font-size: 1rem;
  color: #000000;
  margin-right: 8px;
`;
const SpanCount = styled.span`
  font-weight: 400;
  font-size: 1rem;
  margin-right: 16px;
  color: #e04132;
`;
const DivMuiName = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
`;

const WrapperText = styled.div`
  // margin-bottom: 32px;
  width: 45%;
  position: relative;
  display: flex;
  justify-content: center;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;
const WrapperStatus = styled.div`
  width: 25%;
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 8px;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;
const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;
const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const DrawerHeader = MatStyled.styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

function SellerList({ open }) {
  const { user, checkAllowPermission } = useAuth();
  const navigate = useNavigate();
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const [sellerListData, setSellerListData] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    page: 0,
    page_size: 10,
    status: "all",
  });
  const [rowCount, setRowCount] = useState(0);
  const [isShowModalSell, setIsShowModalSell] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [idSell, setIdSell] = useState(null);
  // function CustomPagination() {
  //   const apiRef = useGridApiContext();
  //   const page = useGridSelector(apiRef, gridPageSelector);
  //   const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  //   return (
  //     <WrapperPagination>
  //       <Pagination
  //         color="primary"
  //         count={pageCount}
  //         page={page + 1}
  //         onChange={(event, value) => apiRef.current.setPage(value - 1)}
  //       />
  //     </WrapperPagination>
  //   );
  // }
  const handleStatusQuo = (id) => {
    if (id === 0) {
      return getLocale() === "th" ? "รออนุมัติ" : "Pending";
    } else if (id === 1) {
      return getLocale() === "th" ? "อนุมัติ" : "Approve";
    } else if (id === 2) {
      return getLocale() === "th" ? "ไม่อนุมัติ" : "Reject";
    }
  };
  const columns = [
    {
      field: "brand_name",
      headerName: "Seller",
      flex: 2,
      // width: 200,
      editable: false,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              margin: "8px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <div style={{ margin: "8px", width: "100%" }}>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  marginBottom: "8px",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Name : {params.row?.brand_name}
              </div>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  marginBottom: "8px",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                E-mail : {params.row?.email ? params.row?.email : "-"}
              </div>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  marginBottom: "8px",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Tel : {params.row?.phone_number}
              </div>
            </div>
          </Box>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date Request",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params?.row?.createdAt
              ? moment(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {!!params.row?.status_update && params.row?.status_update === 1
              ? getLocale() === "th"
                ? "รออนุมัติการแก้ไข"
                : "Update Pending"
              : handleStatusQuo(params.row?.is_approve)}
          </div>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditRoundedIcon />}
          label="Set Payment"
          disabled={!checkAllowPermission("sellers.can_setting")}
          onClick={() => {
            setIsShowModalSell(true);
            setIdSell(params.row._id);
          }}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<LocalShippingIcon />}
          label="Set Delivery Type"
          disabled={!checkAllowPermission("sellers.can_setting")}
          onClick={() =>
            openDialog({
              type: "custom",
              customDialog: (
                <SetDeliveryTypeDialog
                  sellerId={params.row._id}
                  sellerDeliveryTypes={params?.row?.seller_delivery_types}
                  onClose={() => closeDialog()}
                  onSuccess={() => {
                    closeAllDialogs();
                  }}
                />
              ),
            })
          }
          showInMenu
        />,
        <GridActionsCellItem
          icon={<EditNoteIcon />}
          label="Set Contract Fee"
          onClick={() =>
            openDialog({
              type: "custom",
              customDialog: (
                <SetTermContractFeeDialog
                  userData={params.row}
                  onClose={() => closeDialog()}
                  onSuccess={() => {
                    onSearchButton();
                    closeAllDialogs();
                  }}
                />
              ),
            })
          }
          showInMenu
        />,
        <GridActionsCellItem
          icon={<DescriptionIcon />}
          label="Terms"
          onClick={() =>
            openDialog({
              type: "custom",
              customDialog: (
                <TermDialog
                  userData={params.row}
                  onClose={() => closeDialog()}
                />
              ),
            })
          }
          showInMenu
        />,
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Preview"
          onClick={() => navigate(`/seller/detail/${params.row._id}`)}
          showInMenu
        />,
      ],
    },
  ];

  function NoRowsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  }

  function NoResultsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  }

  const onSearchButton = () => {
    setDataSearch({ ...dataSearch, page: 0 });
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        const { data } = await getSellerListAdmin({ ...dataSearch, page: 0 });
        setSellerListData(data.data.rows);
        setRowCount(data);
        setIsLoading(false);
      }
    })();
  };

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch, page: newPage });
  };
  useEffect(() => {
    setIsLoading(true);
    (async () => {
      if (user.role_id === 1) {
        const { data } = await getSellerListAdmin(dataSearch);
        setSellerListData(data.data.rows);
        setRowCount(data);
        setIsLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page, dataSearch.status]);

  return (
    <>
      <Main open={open}>
        <DrawerHeader />
        <DivMuiName>
          <DivCount>
            <SpanTextCount>ผู้ขายทั้งหมด :</SpanTextCount>
            <SpanCount>{rowCount?.all}</SpanCount>
            <SpanTextCount>ผู้ขายใหม่ :</SpanTextCount>
            <SpanCount>{rowCount?.pending}</SpanCount>
          </DivCount>
          <DivMuiInside>
            <WrapperText>
              <TextField
                id="search-input"
                placeholder="ค้นหาจากชื่อร้านค้า อีเมลล์ หรือ เบอร์โทร"
                className="TextField-without-border-radius"
                sx={{
                  m: 1,
                  width: "100%",
                  borderRadius: "16px",
                }}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      id="button-search-seller"
                      sx={{ padding: 0 }}
                      onClick={() => {
                        onSearchButton();
                      }}
                    >
                      <SearchIcon
                        sx={{ color: "#e04132", cursor: "pointer" }}
                      />
                    </IconButton>
                  ),
                }}
                onChange={(e) => {
                  setDataSearch({ ...dataSearch, keyword: e.target.value });
                }}
                onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
              />
            </WrapperText>
            <WrapperStatus>
              <FormControl fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                  className="TextField-without-border-radius"
                  id="search-input"
                  label="Age"
                  onChange={(e) => {
                    setDataSearch({ ...dataSearch, status: e.target.value });
                  }}
                >
                  <MenuItem value={"all"}>All</MenuItem>
                  <MenuItem value={"new"}>New</MenuItem>
                  <MenuItem value={"approve"}>Approve</MenuItem>
                  <MenuItem value={"pending"}>Pending</MenuItem>
                  <MenuItem value={"reject"}>Reject</MenuItem>
                </Select>
              </FormControl>
            </WrapperStatus>

            {/* <WrapperButton>
              <Button
                className="Button-Add"
                startIcon={<AddIcon />}
                onClick={() => navigate("/product/upload")}
              >
                อัพโหลดสินค้า
              </Button>
            </WrapperButton> */}
          </DivMuiInside>

          <WrapperDataGrid>
            <DataGrid
              rows={sellerListData}
              getRowId={(row) => row._id}
              getRowHeight={() => "auto"}
              loading={isLoading}
              columns={columns}
              pageSize={10}
              rowCount={rowCount.data?.count}
              paginationMode="server"
              page={dataSearch.page}
              onPageChange={(e) => handlePageChange(e)}
              rowsPerPageOptions={[10]}
              pagination
              disableSelectionOnClick
              // localeText={{
              //   footerRowSelected: CustomPagination,
              // }}
              components={{
                // Footer: CustomPagination,
                NoRowsOverlay,
                NoResultsOverlay,
              }}
              componentsProps={{
                basePopper: {},
              }}
              sx={{
                "& .MuiDataGrid-actionsCell": {
                  transform: "rotate(90deg)",
                },
              }}
            />
          </WrapperDataGrid>
        </DivMuiName>
        {isShowModalSell ? (
          <ModalSetSellNow
            close={(disp) => setIsShowModalSell(disp)}
            id={idSell}
          />
        ) : null}
      </Main>
    </>
  );
}

export default SellerList;
